module.exports = __webpack_public_path__ + "assets/img/37_1637.b8034654.jpg";